import { Button, Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import OffWarrantyFilterForm from './OffWarrantyFilterForm';
import type useWarrantyFilters from './model/useWarrantyFilters';

interface OffWarrantyFilterProps {
    filter: ReturnType<typeof useWarrantyFilters>;
}

const OffWarrantyFilter = ({ filter }: OffWarrantyFilterProps) => {
    const { t } = useTranslation(['Warranties', 'common']);

    return (
        <Offcanvas show={filter.show} onHide={filter.close} placement="end">
            <Offcanvas.Header closeButton className="border-bottom">
                <Offcanvas.Title>{t('filterTitle')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                <div className="off-filter-form d-flex flex-column h-100">
                    <div className="off-filter-content px-3">
                        <OffWarrantyFilterForm filter={filter} />
                    </div>
                    <div className="p-3 offcanvas-footer off-filter-footer">
                        <div className="d-flex justify-content-end gap-2">
                            <Button variant="secondary" onClick={filter.reset}>
                                {t('common:buttons.reset')}
                            </Button>
                            <Button variant="info" className="min100px" onClick={filter.apply}>
                                {t('common:buttons.apply')}
                            </Button>
                        </div>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default OffWarrantyFilter;
